/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faint_Sage_Panda_YawnInputs */

const en_faint_sage_panda_yawn = /** @type {(inputs: Faint_Sage_Panda_YawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resend notification`)
};

const de_faint_sage_panda_yawn = /** @type {(inputs: Faint_Sage_Panda_YawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigung erneut senden`)
};

/**
* | output |
* | --- |
* | "Resend notification" |
*
* @param {Faint_Sage_Panda_YawnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const faint_sage_panda_yawn = /** @type {((inputs?: Faint_Sage_Panda_YawnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faint_Sage_Panda_YawnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faint_sage_panda_yawn(inputs)
	return de_faint_sage_panda_yawn(inputs)
});